import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CheckCircleIcon } from "lucide-react";
import { useLocation } from "wouter";

export default function VerificationSuccess() {
  const [, setLocation] = useLocation();
  
  const handleLoginClick = () => {
    setLocation("/auth");
  };

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader>
        <CardTitle className="text-2xl text-center">Email Verified</CardTitle>
        <CardDescription className="text-center">
          Your email has been successfully verified
        </CardDescription>
      </CardHeader>
      
      <CardContent>
        <div className="flex flex-col items-center justify-center p-6">
          <div className="mb-4 rounded-full bg-primary/10 p-3">
            <CheckCircleIcon className="h-12 w-12 text-primary" />
          </div>
          
          <Alert className="mb-4 border-green-500">
            <CheckCircleIcon className="h-5 w-5 text-green-500" />
            <AlertTitle className="text-green-500">Success!</AlertTitle>
            <AlertDescription>
              Your email has been verified successfully. You can now log in to your account.
            </AlertDescription>
          </Alert>
        </div>
      </CardContent>
      
      <CardFooter>
        <Button
          variant="default"
          className="w-full"
          onClick={handleLoginClick}
        >
          Go to Login
        </Button>
      </CardFooter>
    </Card>
  );
}